<div *ngIf="!isPageRendered()" class="text-light toolbox-book-list">
  <app-open-planned-book [participantUuid]="participantUuid"></app-open-planned-book>
  <app-book-list (selected)="openBook($event)" [participantUuid]="participantUuid"></app-book-list>
</div>
<app-book-renderer [hidden]="!isPageRendered()" [participantUuid]="participantUuid" (displayChart)="onDisplayChart($event)"></app-book-renderer>
